"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var r=_styled2.default.div`
  & .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
    margin-right: ${e=>e.theme.measurements.spacing(2)};
  }

  & .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
    margin-right: ${e=>e.theme.measurements.spacing(2)};
  }
`,n=_styled2.default.div`
  width: ${e=>e.theme.measurements.shape(3)};
  height: ${e=>e.theme.measurements.shape(3)};
  background-color: ${e=>e.$background||e.theme.palette.WHITE};
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1s infinite ease-in-out both;

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0.5);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
`;function i(e){let{$background:a,className:t}=e;return _jsxruntime.jsxs.call(void 0, r,{className:t,children:[_jsxruntime.jsx.call(void 0, n,{className:"bounce bounce1",$background:a}),_jsxruntime.jsx.call(void 0, n,{className:"bounce bounce2",$background:a}),_jsxruntime.jsx.call(void 0, n,{className:"bounce bounce3",$background:a})]})}var u=i;exports.a = u;
